import useCommonApi from "../api/useCommonApi";

export interface IClienteDistribuidorInHouse {
    clienteID: number;
    clienteDistribuidorID: number;
    nombreClienteDistribuidor: string;
    codigoPostal?: string;
    paisID?: number;
    estadoID?: number;
    ciudadID?: number;
    coloniaID?: number;
    calle?: string;
    noExterior?: string;
    noInterior?: string;
    direccion?: string;
    esInHouse?: boolean;
    colonium?: any;
}

const useGetClienteDistribuidorInHouse = () => {
    const apiSource = useCommonApi();

    const obtenerInHousePorCliente = async (clienteId: number): Promise<IClienteDistribuidorInHouse[]> => {
        const result = await apiSource.obtenerAsync<IClienteDistribuidorInHouse[]>(
            `cliente-distribuidor/in-house-by-cliente/${clienteId}`
        );
        return result || [];
    };

    return { obtenerInHousePorCliente };
};

export default useGetClienteDistribuidorInHouse;
